module.exports = __webpack_public_path__ + "static/media/fish_farm_bg2.a7f28972.png";